// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_vpuUW {
  display: flex;
  padding: 0px 20px 0px 10px;
  align-items: center;
  background: var(--white-background);
  justify-content: space-between;
  height: 60px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.contentTelematel_j9e6A {
  display: flex;
  padding: 0px 10px;
  align-items: center;
  background: var(--white-background);
  justify-content: space-between;
  min-height: 55px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  /* max-width: 380px; */
  width: 100%;
}

.dateAutomate_kToTa {
  font-size: 13px;
  color: #4F5660;
}

.content_vpuUW:hover {
  background-color: var(--fa-background);
}

.contentTelematel_j9e6A:hover {
  background-color: var(--fa-background);
}

.content_active_CI2NX {
  background-color: var(--ececf1-background);
}

.content_disabled_yrkin {
  background-color: var(--f1-background) !important;
  opacity: 0.3;
  cursor: no-drop;
}

.content_panel_D8sX5 {
  background: transparent;
  border-radius: 4px;
  height: 54px;
  padding: 0 5px;
  box-sizing: border-box;

  @media (width<=900px) {
    display: flex;
    justify-content: center;

  }
}

.content_panel_D8sX5:hover {
  background-color: var(--ececf1-background);
}

.data_contain_cwcl0 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  .title_YsuRt {
    @media (width<=768px) {
      display: none;
      color:var(--_2-color)
    }
  }


  .boxShadow_omyKB {
    border: 1px solid var(--ef-border);
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  

  
  .icon_wf0QM {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    background: var(--f5-background);
    border-radius: 100px;
    position: relative;

    .image_xonJS {
      width: 34px;
      height: 34px;
    }

    &.panelAutomate_CiG2N {
      width: 34px;
      height: 34px;
      /* background: var(--f5-background); */
      .image_xonJS {
        width: 64px;
        height: 64px;
      }
    }
  }
  
}


.automate_name_eNdc4 {
  font-size: 14px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.contact_ek2Gz {
  margin-top: 0;
  color: var(--_71717a-color);
}

.buttons_contains_XMbNa {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  button {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }

  div {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
}

.button_edit_ggS66 {
  border: none;
  background-color: transparent;
  text-decoration: underline;
  font-weight: 700;
  font-size: 16px;
}


.labelsContainer_yDRsU {
  display: flex;
  overflow-x: auto;
  gap: 5px;
  padding: 10px 0px;
  white-space: nowrap;
  width: 335px;
  max-width: 600px;
  flex-wrap: wrap;
}

.labelsContainer_yDRsU::-webkit-scrollbar {
  display: none;
}

.buttonLabel_o0szk {
  border: none;
  background-color: var(--_4f5660-color);
  font-weight: 500;
  font-size: 12px;
  color: var(--white-color);
  padding: 3px 10px;
  border-radius: 8px;
  gap: 5px;
  cursor: pointer;

  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadingImage_RRZ7I {
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 100px;
  background: var(--f5-background);
}

/* Estilos para el indicador de progreso circular */
.progressContainer__UZ_3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressSvg_MQsPJ {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progressBackground_s3Vy1 {
  fill: none;
  stroke: #e5e7eb;
  stroke-width: 2;
}

.progressBar_URoLP {
  fill: none;
  stroke: #10b981;
  stroke-width: 2;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.timerText_UzzgZ {
  position: absolute;
  font-size: 8px;
  font-weight: 600;
  color: #374151;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -2px;
  right: -2px;
}

.redContainer_j_9fe{
  background-color: #C5221F;
  color: white;
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 4px;
}

.greenContainer_PQ_K3{

  background-color:var(--_10a37f-background);
  color: white;
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/CardAutomate/cardAutomate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,sBAAsB;;EAEtB;IACE,aAAa;IACb,uBAAuB;;EAEzB;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;;EAEX;IACE;MACE,aAAa;MACb;IACF;EACF;;;EAGA;IACE,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;;;EAIA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;;IAElB;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,sCAAsC;MACtC;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;;AAEF;;;AAGA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,eAAe;;EAEf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".content {\n  display: flex;\n  padding: 0px 20px 0px 10px;\n  align-items: center;\n  background: var(--white-background);\n  justify-content: space-between;\n  height: 60px;\n  user-select: none;\n  cursor: pointer;\n}\n\n.contentTelematel {\n  display: flex;\n  padding: 0px 10px;\n  align-items: center;\n  background: var(--white-background);\n  justify-content: space-between;\n  min-height: 55px;\n  user-select: none;\n  cursor: pointer;\n  /* max-width: 380px; */\n  width: 100%;\n}\n\n.dateAutomate {\n  font-size: 13px;\n  color: #4F5660;\n}\n\n.content:hover {\n  background-color: var(--fa-background);\n}\n\n.contentTelematel:hover {\n  background-color: var(--fa-background);\n}\n\n.content_active {\n  background-color: var(--ececf1-background);\n}\n\n.content_disabled {\n  background-color: var(--f1-background) !important;\n  opacity: 0.3;\n  cursor: no-drop;\n}\n\n.content_panel {\n  background: transparent;\n  border-radius: 4px;\n  height: 54px;\n  padding: 0 5px;\n  box-sizing: border-box;\n\n  @media (width<=900px) {\n    display: flex;\n    justify-content: center;\n\n  }\n}\n\n.content_panel:hover {\n  background-color: var(--ececf1-background);\n}\n\n.data_contain {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n\n  .title {\n    @media (width<=768px) {\n      display: none;\n      color:var(--_2-color)\n    }\n  }\n\n\n  .boxShadow {\n    border: 1px solid var(--ef-border);\n    height: 35px;\n    width: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n  }\n  \n\n  \n  .icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    background: var(--f5-background);\n    border-radius: 100px;\n    position: relative;\n\n    .image {\n      width: 34px;\n      height: 34px;\n    }\n\n    &.panelAutomate {\n      width: 34px;\n      height: 34px;\n      /* background: var(--f5-background); */\n      .image {\n        width: 64px;\n        height: 64px;\n      }\n    }\n  }\n  \n}\n\n\n.automate_name {\n  font-size: 14px;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.contact {\n  margin-top: 0;\n  color: var(--_71717a-color);\n}\n\n.buttons_contains {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n\n  button {\n    cursor: pointer;\n    user-select: none;\n  }\n\n  div {\n    cursor: pointer;\n    user-select: none;\n  }\n}\n\n.button_edit {\n  border: none;\n  background-color: transparent;\n  text-decoration: underline;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n\n.labelsContainer {\n  display: flex;\n  overflow-x: auto;\n  gap: 5px;\n  padding: 10px 0px;\n  white-space: nowrap;\n  width: 335px;\n  max-width: 600px;\n  flex-wrap: wrap;\n}\n\n.labelsContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.buttonLabel {\n  border: none;\n  background-color: var(--_4f5660-color);\n  font-weight: 500;\n  font-size: 12px;\n  color: var(--white-color);\n  padding: 3px 10px;\n  border-radius: 8px;\n  gap: 5px;\n  cursor: pointer;\n\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadingImage {\n  position: absolute;\n  width: 34px;\n  height: 34px;\n  border-radius: 100px;\n  background: var(--f5-background);\n}\n\n/* Estilos para el indicador de progreso circular */\n.progressContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.progressSvg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.progressBackground {\n  fill: none;\n  stroke: #e5e7eb;\n  stroke-width: 2;\n}\n\n.progressBar {\n  fill: none;\n  stroke: #10b981;\n  stroke-width: 2;\n  stroke-linecap: round;\n  transition: stroke-dasharray 0.3s ease;\n}\n\n.timerText {\n  position: absolute;\n  font-size: 8px;\n  font-weight: 600;\n  color: #374151;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: -2px;\n  right: -2px;\n}\n\n.redContainer{\n  background-color: #C5221F;\n  color: white;\n  padding: 2px 4px;\n  font-size: 12px;\n  border-radius: 4px;\n}\n\n.greenContainer{\n\n  background-color:var(--_10a37f-background);\n  color: white;\n  padding: 2px 4px;\n  font-size: 12px;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_vpuUW`,
	"contentTelematel": `contentTelematel_j9e6A`,
	"dateAutomate": `dateAutomate_kToTa`,
	"content_active": `content_active_CI2NX`,
	"content_disabled": `content_disabled_yrkin`,
	"content_panel": `content_panel_D8sX5`,
	"data_contain": `data_contain_cwcl0`,
	"title": `title_YsuRt`,
	"boxShadow": `boxShadow_omyKB`,
	"icon": `icon_wf0QM`,
	"image": `image_xonJS`,
	"panelAutomate": `panelAutomate_CiG2N`,
	"automate_name": `automate_name_eNdc4`,
	"contact": `contact_ek2Gz`,
	"buttons_contains": `buttons_contains_XMbNa`,
	"button_edit": `button_edit_ggS66`,
	"labelsContainer": `labelsContainer_yDRsU`,
	"buttonLabel": `buttonLabel_o0szk`,
	"loadingImage": `loadingImage_RRZ7I`,
	"progressContainer": `progressContainer__UZ_3`,
	"progressSvg": `progressSvg_MQsPJ`,
	"progressBackground": `progressBackground_s3Vy1`,
	"progressBar": `progressBar_URoLP`,
	"timerText": `timerText_UzzgZ`,
	"redContainer": `redContainer_j_9fe`,
	"greenContainer": `greenContainer_PQ_K3`
};
export default ___CSS_LOADER_EXPORT___;
